import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { apiService } from '@/services/api/apiService';

export interface Address {
    areaCode: any;
    cityName: any;
    coveredAreas: any;
    addressName: any;
    id: number;
    cityId: number;
    isActive: boolean;
    landmark?: string | null;
    latitude: string;
    postCode: string;
    isDefault: boolean;
    longitude: string;
    addressLine1: string;
    addressLine2: string;
    auditTrailId?: number | null;
    addressTypeId: number;
    userProfileId: number;
    addressTypeName: string;
    data: any;
}

export interface AddressState {
    loading: boolean;
    data: Address[];
    error: string | null;
}
const PORT = import.meta.env.VITE_USERS_PORT;
const URL = import.meta.env.VITE_API_USERS_URL;

// Thunk
export const customSearchAddress = createAsyncThunk<
    Address[],
    { userProfileId: number | string, areaCodeId?: any },
    { rejectValue: string }
>('customSearchAddress/customSearchAddress', async (params, { rejectWithValue }) => {
    try {
        const config = { params };
        const response = await apiService.get<{
            data: Address;
            isSuccess: boolean;
            status: number;
        }>('custom_search_address', PORT, URL, config);

        return response.data.data;
    } catch (error: any) {
        return rejectWithValue(error.message || 'An error occurred');
    }
});


const initialState: AddressState = {
    loading: false,
    data: [],
    error: null,
};

const customSearchAddressSlice = createSlice({
    name: 'customSearchAddress',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(customSearchAddress.pending, (state) => {
                state.loading = true;
            })
            .addCase(customSearchAddress.fulfilled, (state, action: PayloadAction<Address[]>) => {
                state.loading = false;
                state.data = action.payload;
            })

            .addCase(customSearchAddress.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? action.error.message ?? 'Something went wrong';
            });
    },
});

export default customSearchAddressSlice.reducer;

